import React, { useContext, useState, useEffect, useCallback, useMemo } from "react";
import styled from "styled-components";
// import { Modal } from "@redq/reuse-modal";
import Modal from 'react-bootstrap/Modal'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { doSupplierLogin } from "../../store/actions/authAction";
import { AuthContext } from "../../contexts/auth/auth.context";
import UploadService from "../../services/FileUploadService";
import * as Constants from "../../constants/Constant";
import axios from "axios";
import { Table } from 'react-bootstrap';
import * as Constant from "../../constants/Constant";
import "bootstrap/dist/css/bootstrap.min.css";
import Loader from "../../components/Loader/Loader";
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
//import "bootstrap/js/src/collapse.js";
import {getCategory, setLoading} from '../../store/actions/dashboardAction'
import { connect } from "react-redux";
import API from "../../network/dashboardAPI"
import { AppBar, Dialog, DialogContent, DialogTitle, IconButton, LinearProgress, Paper, Table as MTable, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Toolbar, Button as MButton, makeStyles, colors, TextField, DialogActions, Grid, Typography, CircularProgress } from "@material-ui/core";
import { Close, Description } from "@material-ui/icons";

const Heading = styled.h3`
  font-size: 21px;
  font-weight: 700;
  color: #0d1136;
  line-height: 1.2;
  margin-bottom: 25px;
  width: 100%;
  text-align: center;
`;

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

export const HelpPageContainer = styled.div`
  background-color: transparent;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  min-height: 400px;
  @media (min-width: 1100px) {
    width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 989px) {
    padding: 60px;
  }
`;
const TableContent = styled.div`
	table {
		thead tr th {
			width: initial;
			vertical-align: middle;
			font-weight: 700;
			font-size: 0.95rem;
			background: #efefef;
		}

		tbody tr td {
			vertical-align: middle;
			white-space: nowrap;
			font-size: 0.95rem;
		}
	}

	.MuiDialogContent-dividers {
		padding: 16px;
	}

	.MuiTableContainer-root {
		::-webkit-scrollbar {
			width: 9px;
			height: 9px;
			border-radius: 3px;
		}

		::-webkit-scrollbar-thumb {
			background: #dee2e6;
			border-radius: 3px;

			&:hover {
				background: #9c9a9a;
			}
		}
	}
`;

const logo = {
  height : "50Px",
  width : "50Px"
}


const useStyles = makeStyles({
  topScrollPaper: {
    alignItems: 'flex-start',
  },
  topPaperScrollBody: {
    verticalAlign: 'top',
  },
  toolbar: {
      padding: 0
  }
});

const CategoryListing = (props) => {

      const classes = useStyles();
      const { authDispatch } = useContext(AuthContext);
      let admin = localStorage.getItem("admin");
      let parsedUser = JSON.parse(admin);
      if(!admin) {
        window.location.href = "/";
      }

      const [showEnable, setShowEnable] = useState(false);
      const [showDisable, setShowDisable] = useState(false);
      const [modalHead,setModalHead] = useState("");
      const [modalMessage,setModalMessage] = useState("");
      const [editId, setEditId] = useState(null);
      const [available,setAvailable] = useState(0);
      const [showImage, setShowImage] = useState(false);
      const [imgUrl , setImgUrl] = useState("")
      const [categoriesData, setCategoriesData] = useState([])
      const [openDialogSequence, setOpenDialogSequence] = useState(false);
      const [draggedItem, setDraggedItem] = useState(null);
      const [submitting, setSubmitting] = useState(false);
      const toggleDialogSequence = () => {
        setOpenDialogSequence((prev) => !prev);
        if(!openDialogSequence) getActiveCategories();
      }
      const handleDragStart = (e, item) => {
        setDraggedItem(item);
      };
    
      const handleDragOver = e => {
        e.preventDefault();
      };
    
      const handleDrop = async (e, droppedItem) => {
        e.preventDefault();
        if(submitting) return;
        if (droppedItem.cat_id === draggedItem.cat_id) return;
    
        const updatedItems = [...categoriesData];
        const draggedIndex = updatedItems.findIndex((item) => item.cat_id === draggedItem.cat_id)
        const droppedIndex = updatedItems.findIndex((item) => item.cat_id === droppedItem.cat_id)
        const [item] = updatedItems.splice(draggedIndex, 1);
        updatedItems.splice(droppedIndex, 0, item);
        let postData = {
          cat_id: item.cat_id,
          order: droppedIndex + 1,
        }
        await updateCategoriesOrder(postData)
        setCategoriesData(updatedItems)
        setDraggedItem(null);
      };

      const getActiveCategories  = async () => {
        API.getCategory({"store_id" : 1,"get_type" : 0 })
        .then((response) => response.json())
        .then((response)=>{
            setCategoriesData(response.data)
          })
          .catch((error) => {
            console.log(error);
          });
      }

      const updateCategoriesOrder = async (data) => {
        props.setLoading(true);
        API.updateCategoryOrder(data)
          .then((response) => {
            props.setLoading(false);
            props.getCategory({
              store_id: 1,
              get_type: 1,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      };

      const [loading, setLoading] = useState(false);
      const [subCategories, setSubCategories] = useState([]);
      const [subCategoryTotal, setSubCategoryTotal] = useState(0);
      const [page, setPage] = useState(0);
      const [perPage, setPerPage] = useState(10);
      const [dialogOpen, setDialogOpen] = useState(false);
      const [dialogUpdateOpen, setDialogUpdateOpen] = useState(false);
      const [category, setCategory] = useState(null);
      const [selectedSubcategory, setSelectedSubcategory] = useState({});

      const isValidPositionNumber = useMemo(() => {
        const regex = /^-?\d*\.?\d+$/;
        return regex.test(selectedSubcategory?.order);
    }, [selectedSubcategory]);

      const handleToggleDialog = (category = null) => {
        console.log(category);
        setDialogOpen((prev) => !prev);
        setCategory(category);
      }

      const handleToggleDialogUpdate = (item = {}) => {
        setDialogUpdateOpen((prev) => !prev);
        setSelectedSubcategory(item);
      } 

      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      }

      const handleChangeRowPerPage = (event) => { 
        setPage(0);
        setPerPage(parseInt(event.target.value, 10));
      }

      const handleChangePosition = (event) => {
        if(selectedSubcategory) {
            setSelectedSubcategory((value) => ({ ...value, order: event.target.value }))
        }
      }

      const handleGetSubCatsType = useCallback((catId, page, limit) => {
        if(!catId) return;
        setLoading(true);
        API.getSubCatsType(catId, page + 1, limit)
          .then((response) => response.json())
          .then((response) => {
              if(response.success) {
                setSubCategories(response.data.list)
                setSubCategoryTotal(response.data.total)
              }
              setLoading(false);
          })
          .catch((err) => {
              setLoading(false);
              console.log(err);
          })
      }, []);

      const handleUpdateSubCatTypeSequence = () => {
        if(!isValidPositionNumber) return;
        const body = {
          catId: category?.cat_id,
          subCatId: selectedSubcategory?.sub_cat_id,
          order: selectedSubcategory?.order
        }

        setSubmitting(true);
        API.updateSubCatsTypeSequence(body)
          .then((response) => response.json())
          .then((response) => {
              if(response.success) {
                  setDialogUpdateOpen(false);
                  handleGetSubCatsType(category?.cat_id, page, perPage);
              }
              setSubmitting(false);
          })
          .catch((err) => {
              setSubmitting(false);
              console.error(err);
          })
      }

      useEffect(() => {
        handleGetSubCatsType(category?.cat_id, page, perPage);
      }, [handleGetSubCatsType, perPage, page, category]);

      const hnadleShowImageClose = () => {
          setShowImage(false)
      }

      const hnadleShowImageOpen = (url) => {
          setImgUrl(url)
          setShowImage(true)
      }

      const addcategoryPage = (event) => {
        window.location.href = "/admin/categorie/add";
      }

      const handleClose = () => {
        setShowEnable(false);
        setShowDisable(false);
      }

      const enableModal = (proId,proName) => {
        setEditId(proId);
        setAvailable(1);
        setModalHead("Enable");
        setModalMessage("Want to enable Category - '"+proName+"'?");
        setShowEnable(true);
        console.log("here"+proId+proName)
      };

      const disableModal = (proId,proName) => {
        setEditId(proId);
        setAvailable(0);
        setModalHead("Disable");
        setModalMessage("Want to disable Category - '"+proName+"' ?");
        setShowDisable(true);
        console.log("here"+proId+proName)
      };
      const enableProduct = () => {
          setModalHead("Updating");
          API.updatenableDisableCategory({
            id: editId,
            availability: available,
            get_type : 1
          })
          .then(response => {
              setShowEnable(false);
              setShowDisable(false);
              props.getCategory({
                "store_id" : 1,
                "get_type" : 1 
              })
          }).catch((error) => {
              setModalHead(error);
          });
        }

      useEffect(() => {
        props.getCategory({
            "store_id" : 1,
            "get_type" : 1 
          })
      },[])


      let content = null;
      if(props.categories){
          content = props.categories.map((categorie,index)=>
         
            <tr key = {index}  >
            <td onClick= {()=>hnadleShowImageOpen(categorie.list_categories[0].image)} ><img src={categorie.list_categories[0].image} alt="img" style = {logo} /></td>
            <td>{categorie.cat_id}</td>
            <td>{categorie.list_categories[0].name}</td>
            <td>{categorie.list_categories[0].name_km}</td>
            <td>{!categorie.list_categories[0].order ? 0 : categorie.list_categories[0].order }</td>
            <td>{categorie.is_available === 1 ? 
                (
                    <Button variant="success" onClick={() => disableModal(categorie.cat_id,categorie.list_categories[0].name)}>
                        Enabled
                    </Button>
                ) : (
                    <Button variant="danger" onClick={() => enableModal(categorie.cat_id,categorie.list_categories[0].name)}>
                        Disabled
                    </Button>
                )}
            </td>
            <td>
                <Link to={{ pathname: '/admin/categorie/update', state: {cat_id: categorie.cat_id,name : categorie.list_categories[0].name, name_km : categorie.list_categories[0].name_km, image : categorie.list_categories[0].image } }}>
                    <Button variant="info" type="submit">
                        <EditIcon></EditIcon>
                    </Button>
                </Link>
                <Button
                  className="ml-2"
                  style={{ height: "fit-content"}}
                  onClick={() => handleToggleDialog(categorie)}
                >
                  <Description />
                </Button>
            </td>
        </tr>
        
      )}
    

    return (
    
      <HelpPageWrapper>
        <Row>
            <Col>
              <Button variant="success" type="submit" className="mb-5" onClick={addcategoryPage }>
                  Add category
              </Button>
              <Button variant="success" className="mb-5 ml-2" onClick={toggleDialogSequence}>Sort app categories</Button>
            </Col>
        </Row>
        <Row>
            <Col sm={11}>
              { !content?<div style = {{position: "fixed" , left: "55%" , top : "35%"}} > <Loader   color = "#9cc54b" h = "100"/> </div> :
              <Table striped bordered hover>
                <thead>
                      <tr>
                         <th>Image</th>
                          <th>ID</th>
                          <th>Categorie Name</th>
                          <th>Categorie Name (Khmer)</th>
                          <th>Position</th>
                          <th>Available</th>
                          <th>Edit</th>
                      </tr>
                  </thead>
                  <tbody >

                   { content}
                   </tbody>
              </Table>
            }
            </Col>
        </Row>
        <div>

        {/* Dialog for Sub-category list */}
        <Dialog
          open={dialogOpen}
          onClose={handleToggleDialog}
          fullWidth
          maxWidth="xl"
          scroll="body"
          classes={{
            scrollPaper: classes.topScrollPaper,
            paperScrollBody: classes.topPaperScrollBody,
          }}
        >
          <AppBar
            color="transparent"
            variant="outlined"
            style={{ position: "relative" }}
          >
            <Toolbar classes={{ root: classes.toolbar }}>
              <DialogTitle style={{ flex: 1 }}>
                SubCategories of {category?.list_categories?.[0]?.name}
              </DialogTitle>
              <IconButton
                edge="end"
                color="inherit"
                onClick={handleToggleDialog}
                aria-label="close"
              >
                <Close />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent dividers>
            <TableContent>
              <Paper>
                <TableContainer style={{ maxHeight: window.innerHeight - 220 }}>
                  <MTable stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Position</TableCell>
                        <TableCell align="center">Image</TableCell>
                        <TableCell align="left">Name</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{ position: "relative" }}>
                      {loading && (
                        <div
                          style={{
                            display: "block",
                            position: "absolute",
                            inset: 0,
                            background: "rgb(166 166 166 / 20%)",
                          }}
                        ></div>
                      )}
                      {subCategories.length > 0 ? (
                        subCategories?.map((row) => {
                          return (
                            <TableRow key={row?.sub_cat_id} hover>
                              <TableCell align="center">{row?.order}</TableCell>
                              <TableCell align="center" >
                                <img
                                  src={
                                    row?.banner_image ||
                                    require("./../../assets/icons/delishop_logo2.svg")
                                  }
                                  alt={row?.name}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = require("./../../assets/icons/delishop_logo2.svg");
                                  }}
                                  style={{
                                    display: "inline",
                                    width: 50,
                                    height: "auto",
                                    objectFit: "contain",
                                  }}
                                />
                              </TableCell>
                              <TableCell align="left">{row?.name}</TableCell>
                              <TableCell align="center">
                                <MButton
                                  variant="contained"
                                  color="inherit"
                                  style={{
                                    background: colors["green"]["600"],
                                    color: "#fff",
                                    height: "fit-content",
                                  }}
                                  size="small"
                                  onClick={() => handleToggleDialogUpdate(row)}
                                >
                                  <EditIcon />
                                </MButton>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell align="center" colSpan={4}>
                            No Data
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </MTable>
                </TableContainer>
                <div
                  style={{
                    display: "block",
                    width: "100%",
                    height: "5px",
                  }}
                >
                  {loading && <LinearProgress variant="query" />}
                </div>
                <TablePagination
                  component="div"
                  page={page}
                  rowsPerPage={perPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={subCategoryTotal}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowPerPage}
                />
              </Paper>
            </TableContent>
          </DialogContent>
        </Dialog>

        {/* Dialog for Update Sub-category Position */}
        <Dialog maxWidth="sm" open={dialogUpdateOpen}>
          <DialogTitle>Update {selectedSubcategory?.name} Position ?</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              label="Position"
              placeholder="Enter sub-category position"
              disabled={submitting}
              value={selectedSubcategory?.order}
              onChange={handleChangePosition}
            />
          </DialogContent>
          <DialogActions>
            <MButton
              variant="text"
              color="secondary"
              className="text-capitalize"
              disabled={submitting}
              onClick={handleToggleDialogUpdate}
            >
              Cancel
            </MButton>
            <MButton
              variant="text"
              color="primary"
              className="text-capitalize"
              disabled={submitting || !isValidPositionNumber}
              onClick={handleUpdateSubCatTypeSequence}
            >
              Submit
            </MButton>
          </DialogActions>
        </Dialog>

        <Modal show={showEnable} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>{modalHead}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="success" onClick={enableProduct}>
                    Enable
                </Button>
                </Modal.Footer>
            </Modal>

          <Modal show={showDisable} onHide={handleClose}>
              <Modal.Header closeButton>
              <Modal.Title>{modalHead}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{modalMessage}</Modal.Body>
              <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                  Close
              </Button>
              <Button variant="danger" onClick={enableProduct}>
                  Disable
              </Button>
              </Modal.Footer>
          </Modal>


          <Modal show={showImage} onHide={hnadleShowImageClose}>
            <Modal.Header closeButton>
            <Modal.Title>Image</Modal.Title>
            </Modal.Header>
            <Modal.Body><img alt ="Categories" src = {imgUrl} style = {{height : "400Px" , width : "400Px", alignItems : "center"}}/></Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={hnadleShowImageClose}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

        </div>

        <Dialog
            open={openDialogSequence}
            fullScreen
            onClose={toggleDialogSequence}
          >
            <AppBar
              color="transparent"
              variant="outlined"
              style={{ position: "relative" }}
            >
              <Toolbar>
                <DialogTitle style={{ flex: 1 }}>Organize Categories Sequence</DialogTitle>
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={toggleDialogSequence}
                  aria-label="close"
                >
                  <Close />
                </IconButton>
              </Toolbar>
            </AppBar>
            <DialogContent dividers style={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                {!props.loading ? (
                  categoriesData.length ? (
                    categoriesData.map((data) => (
                      <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        container
                        key={data.cat_id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, data)}
                        onDragOver={(e) => handleDragOver(e)}
                        onDrop={(e) => handleDrop(e, data)}
                        style={{ cursor: "move" }}
                      >
                        <Grid
                          item
                          container
                          xs={12}
                          className={`shadow shadow-sm rounded border p-3 ${
                            submitting ? "bg-light" : "bg-white"
                          }`}
                        >
                          <Grid item xs={12}>
                            <img
                              alt="Logo"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = require("./../../assets/icons/delishop_logo2.svg");
                              }}
                              src={data?.list_categories[0].image}
                              style={{ objectFit: "contain", width: "100%" }}
                              height={120}
                            />
                          </Grid>
                          <Grid item xs={12} className="mt-auto">
                            <Typography variant="body1" component="h1" color="secondary">
                              {data?.list_categories[0].name}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs>
                      No Data
                    </Grid>
                  )
									) : (
										<Grid item xs={12} className="d-flex justify-content-center align-items-center mt-3">
											<div>
                        <CircularProgress color="primary" />
                      </div>
										</Grid>
									)}
              </Grid>
            </DialogContent>
          </Dialog>

      </HelpPageWrapper>
  
    );
}


const mapStateToProps = state =>{
   return {
    categories : state.dashboardReducer.category,
    loading: state.dashboardReducer.loading,
    success: state.dashboardReducer.success
   }
  
 }

 const mapDispatchToProps = dispatch => {
   return {
     getCategory : data => getCategory(data,dispatch),
     setLoading: data => setLoading(data, dispatch)
    }
 }
 
export default connect(mapStateToProps,mapDispatchToProps)(CategoryListing)